export default __webpack_public_path__ + "static/media/noAnnotationIcon.ab36bf65.png";